import { Injectable, signal } from '@angular/core';
import { AccountSettings, Subscription } from '../utils/types';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  subscription = signal<Subscription>({
    isProAccount: false,
    proExpiryDate: null,
    numItemsAddedThisMonth: 0,
    maxNumItemsAdd: 0,
    credCardLastFourDigits: ''
  });

  otherAccountSettings = signal<AccountSettings>({
    optOutWelcomePopup: false,
    maxLengthShortText: 0,
    maxLengthLongText: 0,
    dashboardTheme: {
      name: '',
      title: '',
      image: '',
      dashboardContentClass: '',
    }
  })
  constructor() { }
}
